import { render, staticRenderFns } from "./SelectTipoLayout.vue?vue&type=template&id=fa9b966c&scoped=true&"
import script from "./SelectTipoLayout.vue?vue&type=script&lang=ts&"
export * from "./SelectTipoLayout.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa9b966c",
  null
  
)

export default component.exports